import { render, staticRenderFns } from "./ConfiguratorV2.vue?vue&type=template&id=ecaa9892&scoped=true"
import script from "./ConfiguratorV2.vue?vue&type=script&lang=js"
export * from "./ConfiguratorV2.vue?vue&type=script&lang=js"
import style0 from "./ConfiguratorV2.vue?vue&type=style&index=0&id=ecaa9892&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecaa9892",
  null
  
)

export default component.exports